// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#live_polling_container{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}#live_polling_container #live_polling_box{border:none!important;height:calc(100% - 16px);font-size:14px}#live_polling_container #live_polling_box #polling_content{height:100%;padding:5px;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
